import type { CourseProfile } from '../types/courseProfile';
import { getActiveCourseProfile, getCourseProfileById } from './services/courseProfileStorage';

export function resolveCourseProfile(options?: {
  courseId?: string | null;
  courseProfile?: CourseProfile | null;
}): CourseProfile | null {
  if (options?.courseProfile) return options.courseProfile;
  const courseId = options?.courseId?.trim();
  if (courseId) return getCourseProfileById(courseId);
  return getActiveCourseProfile();
}
